import React, { useEffect } from 'react';
import getScript from './getScript';

function AppsFlyerLoader({ oneLinkURL }) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = getScript(oneLinkURL);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [oneLinkURL]);

  return null;
}

export default AppsFlyerLoader;
